var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 1.66699L13.7498 4.58366L14.9998 10.8337L10.8332 15.0003L4.58317 13.7503L1.6665 1.66699ZM1.6665 1.66699L7.98817 7.98866M9.99984 15.8337L15.8332 10.0003L18.3332 12.5003L12.4998 18.3337L9.99984 15.8337ZM10.8332 9.16699C10.8332 10.0875 10.087 10.8337 9.1665 10.8337C8.24603 10.8337 7.49984 10.0875 7.49984 9.16699C7.49984 8.24652 8.24603 7.50033 9.1665 7.50033C10.087 7.50033 10.8332 8.24652 10.8332 9.16699Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsign);
export default __webpack_public_path__ + "static/media/iconsign.1466ad49ad9f83d658fe3712db1f7226.svg";
export { ForwardRef as ReactComponent };